import { Pipe, PipeTransform, inject, effect, ChangeDetectorRef } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
	name: 'translate',
	standalone: true,
	pure: false // Re-evaluate on every change detection so language switches apply immediately
})
export class TranslatePipe implements PipeTransform {
	private translationService = inject(TranslationService);
	private cdr = inject(ChangeDetectorRef);

	constructor() {
		// Mark the host view for check whenever the language changes. Without
		// this the new texts were rendered only on the next unrelated change
		// detection cycle (which could be minutes later).
		effect(() => {
			this.translationService.language();
			this.cdr.markForCheck();
		});
	}

	// A second argument provides a fallback text for a key that is missing
	// from the translation resources (same convention as
	// TranslationService.translate), instead of showing the raw key.
	transform(key: string, fallback?: string): string {
		// Cheap Map lookup; also registers a signal dependency on the current
		// translations, so signal-based change detection refreshes this view
		return this.translationService.translate(key, fallback);
	}
}
